<div class="po-xl-6 po-lg-6 po-md-12 po-sm-12 account-balance">
  <po-widget>
    <div class="icon-loading" *ngIf="loading && !errorApi">
      <app-loading-icon></app-loading-icon>
    </div>
    <div *ngIf="!loading && errorApi">
      <app-error [message]="message"></app-error>
    </div>
    <div class="po-font-text-bold">Saldo das contas</div>
    <div class="po-md-12">
      <po-table
        [p-columns]="columns"
        [p-infinite-scroll-distance]="80"
        [p-height]="300"
        [p-items]="listItem"
        [p-striped]="true"
        (p-collapsed)="onCollapseDetail()"
        (p-expanded)="onExpandDetail()"
        >
      >
      </po-table>
    </div>
    <!--<div *ngFor="let item of listItem">
      <div class="po-row po-text-center po-font-text-bold billing-value-year">
        <span class="po-xl-12 po-lg-12 po-md-12 po-sm-12"> {{ item.bank_name }} </span>
      </div>
      <div class="po-table-main-container" *ngIf="!loading && !errorApi">
        <div class="po-table-wrapper" style="opacity: 1">
          <div>
            <table class="po-table">
              <thead>
                <tr class="po-table-header">
                  <th class="po-table-header-ellipsis">
                    <div class="po-table-header-flex">
                      <span class="po-table-header-ellipsis"> Agência </span>
                    </div>
                  </th>
                  <th class="po-table-header-ellipsis">
                    <div class="po-table-header-flex">
                      <span class="po-table-header-ellipsis"> Conta </span>
                    </div>
                  </th>
                  <th class="po-table-header-ellipsis">
                    <div class="value-column">
                      <span class="po-table-header-ellipsis"> Valor R$ </span>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody class="po-table-group-row">
                <tr class="po-table-row">
                  <td class="po-table-column" ng-reflect-ng-class="">
                    <div class="po-table-column-cell notranslate">
                      <span>Ag. {{ item.agency }}</span>
                    </div>
                  </td>
                  <td class="po-table-column" ng-reflect-ng-class="">
                    <div class="po-table-column-cell notranslate">
                      <span>CC. {{ item.account_bank }}</span>
                    </div>
                  </td>
                  <td class="po-table-column value-column" ng-reflect-ng-class="">
                    <div class="po-table-column-cell notranslate">
                      <span>{{ item.value_balance_concilied | currency : 'BRL' }}</span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>-->
  </po-widget>
</div>